import { useEffect, useMemo } from 'react';

export function useMovimentoTotaisModule({ itensProdutos = [], dados, setDados, handleMovimento }) {
    const totalValor = useMemo(() => {
        return Array.isArray(itensProdutos)
            ? itensProdutos.reduce((acc, item) => {
                  return item?.pedido ? acc + (Number(item.valorTotal) || 0) : acc;
              }, 0)
            : 0;
    }, [itensProdutos]);

    const parcela = Number(dados?.Prazo?.parcela || 1);

    const valorParcela = useMemo(() => {
        const valor = parcela > 0 ? totalValor / parcela : totalValor;
        return Number(valor.toFixed(2));
    }, [totalValor, parcela]);

    const totalValorFinal = useMemo(() => {
        return Number(Number(totalValor || 0).toFixed(2));
    }, [totalValor]);

    useEffect(() => {
        setDados((prev) => {
            const totalAtual = Number(prev?.totalValor || 0);
            const parcelaAtual = Number(prev?.valorParcela || 0);

            if (totalAtual === totalValorFinal && parcelaAtual === valorParcela) {
                return prev;
            }

            return {
                ...prev,
                totalValor: totalValorFinal,
                valorParcela,
            };
        });
    }, [totalValorFinal, valorParcela, setDados]);

    useEffect(() => {
        handleMovimento?.(itensProdutos);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [itensProdutos]);

    return {
        state: {
            totalValor: totalValorFinal,
            valorParcela,
            parcela,
        },
    };
}
